import styled, { css } from 'styled-components'

import { determineImage } from 'api/apiContstants'

export const ToggleView = styled.div`
    font-weight: 600;
    cursor: pointer;
    color: #222222;
`

export const TableHeader = styled.div`
    text-align: center;
    font-size: 28px;
    font-weight: 600;
`

interface ICurrencyOvalImage {
    currency: string
}

export const CurrencyOvalImage = styled.div<ICurrencyOvalImage>`
    background-image: ${props => `url(${determineImage(props.currency)})`};
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 26px;
    height: 26px;
    margin: 0 15px;
`

export const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .date {
        color: #666666;
    }
`

export const SmallCircle = styled.div`
    background-color: ${props => props.theme.color.status[props.color]};
    border-radius: 100%;
    width: 10px;
    height: 10px;
    margin-right: 10px;
`

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const Pagination = styled.div`
    display: flex;
    margin: 12px 0;
    justify-content: flex-end;
    align-items: center;

    div {
        background-color: ${({ theme }) => theme.color.primary.white};
        border-radius: 4px;
        box-shadow: 0 0 8px 0 ${({ theme }) => theme.color.nav.mainHover};
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 5px;
    }

    svg {
        fill: ${({ theme }) => theme.color.primary.main};
        width: 14px;
        height: 22px;
    }
`

interface IArrow {
    hasPreviousPage?: boolean
    hasNextPage?: boolean
}

export const Arrow = styled.div<IArrow>`
    cursor: pointer;

    ${props =>
        props.hasPreviousPage &&
        css`
            display: none !important;
        `}
    ${props =>
        props.hasNextPage &&
        css`
            display: none !important;
        `}
`
